import {React, useState} from 'react'
import x from "../../../media/x.svg"

const ThankYoupopupBanner = ({ onClose }) => {
  return (
    <div className="popup ">
    <div className="popup-content  content2">
      <div onClick={onClose} className="cross">
        <img src={x} alt="" />
      </div>
      <h2>YOUR REQUEST 
HAS BEEN SUBMITED</h2>
      {/* Add your "Thank you" message content here */}
    </div>
  </div>
  )
}

export default ThankYoupopupBanner
